import { useEffect, useState } from "react";
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from "react-i18next";
import AddWaterMark from "./add-watermark";
import { GetWatermarkSettings } from "../../../Services/Watermark";
import { SettingsIcon } from "lucide-react";
import WatermarkSettings from "../../Settings/watermark-settings";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const ApplyAllImages: React.FunctionComponent<{ onApplyAllImages: any, onChangeMessagehandler: any, processingIds: (string | number)[] }> = (props) => {

    const [openPopUp, setOpenPopUp] = useState<boolean>(false);
    const [stateValue, setIsStateValue] = useState<string>();
    const [loadingItem, setLoadingItem] = useState<any | null>(null);
    const { t } = useTranslation();

    // Listen for watermark applied event to auto-close popup
    useEffect(() => {
        const handleWatermarkApplied = (event: any) => {
            if (event.detail.applied) {
                setOpenPopUp(false);
            }
        };
        window.addEventListener('watermarkApplied', handleWatermarkApplied);
        return () => {
            window.removeEventListener('watermarkApplied', handleWatermarkApplied);
        };
    }, []);

    const EnhancedImageHandler = (data: any) => {
        setLoadingItem(stateValue);
        setOpenPopUp(false);
        props.onApplyAllImages(stateValue, data).then(() => {
            setLoadingItem(null);
        })
            .catch(() => {
                setLoadingItem(null);
            });
    };

    const listEnhancement = [
        {
            id: 1,
            svg: (
                <svg width="16" height="16" className="marg-right-5" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.5 1H2.5C2.10218 1 1.72064 1.15804 1.43934 1.43934C1.15804 1.72064 1 2.10218 1 2.5V13.5C1 13.8978 1.15804 14.2794 1.43934 14.5607C1.72064 14.842 2.10218 15 2.5 15H13.5C13.8978 15 14.2794 14.842 14.5607 14.5607C14.842 14.2794 15 13.8978 15 13.5V2.5C15 2.10218 14.842 1.72064 14.5607 1.43934C14.2794 1.15804 13.8978 1 13.5 1ZM2.5 2H13.5C13.6326 2 13.7598 2.05268 13.8536 2.14645C13.9473 2.24021 14 2.36739 14 2.5V10.5285L11.906 9.0325C11.6397 8.84392 11.3194 8.74684 10.9932 8.75586C10.667 8.76487 10.3525 8.87949 10.097 9.0825L8.537 10.3325L6.933 8.7285C6.68737 8.48409 6.36489 8.332 6.02006 8.29792C5.67523 8.26385 5.32921 8.34989 5.0405 8.5415L2 10.566V2.5C2 2.36739 2.05268 2.24021 2.14645 2.14645C2.24021 2.05268 2.36739 2 2.5 2ZM13.5 14H2.5C2.36739 14 2.24021 13.9473 2.14645 13.8536C2.05268 13.7598 2 13.6326 2 13.5V11.7675L5.595 9.371C5.69113 9.3068 5.80654 9.27789 5.92158 9.28919C6.03663 9.3005 6.1442 9.35132 6.226 9.433L9.1465 12.3535C9.2408 12.4446 9.3671 12.495 9.4982 12.4938C9.6293 12.4927 9.75471 12.4401 9.84741 12.3474C9.94011 12.2547 9.9927 12.1293 9.99384 11.9982C9.99498 11.8671 9.94458 11.7408 9.8535 11.6465L9.2485 11.0415L10.722 9.863C10.807 9.7949 10.9118 9.75639 11.0206 9.75332C11.1295 9.75025 11.2363 9.78279 11.325 9.846L14 11.757V13.5C14 13.6326 13.9473 13.7598 13.8536 13.8536C13.7598 13.9473 13.6326 14 13.5 14Z" fill="white" />
                    <path d="M10 7.5C10.3956 7.5 10.7822 7.3827 11.1111 7.16294C11.44 6.94318 11.6964 6.63082 11.8478 6.26537C11.9991 5.89992 12.0387 5.49778 11.9616 5.10982C11.8844 4.72186 11.6939 4.36549 11.4142 4.08579C11.1345 3.80608 10.7781 3.6156 10.3902 3.53843C10.0022 3.46126 9.60009 3.50087 9.23463 3.65224C8.86918 3.80362 8.55682 4.05996 8.33706 4.38886C8.1173 4.71776 8 5.10444 8 5.5C8 6.03043 8.21071 6.53914 8.58579 6.91421C8.96086 7.28929 9.46957 7.5 10 7.5ZM10 4.5C10.1978 4.5 10.3911 4.55865 10.5556 4.66853C10.72 4.77841 10.8482 4.93459 10.9239 5.11732C10.9996 5.30004 11.0194 5.50111 10.9808 5.69509C10.9422 5.88907 10.847 6.06726 10.7071 6.20711C10.5673 6.34696 10.3891 6.4422 10.1951 6.48079C10.0011 6.51937 9.80004 6.49957 9.61732 6.42388C9.43459 6.34819 9.27841 6.22002 9.16853 6.05557C9.05865 5.89112 9 5.69778 9 5.5C9 5.23478 9.10536 4.98043 9.29289 4.79289C9.48043 4.60536 9.73478 4.5 10 4.5Z" fill="white" />
                </svg>
            ),
            apiName: "Set Best Image Front",
            component: '',
            popUp: false
        },
        {
            id: 2,
            svg: (
                <svg width="16" height="16" className="marg-right-5" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.9932 15.8332H2.09984C1.03317 15.8332 0.166504 14.9666 0.166504 13.8999V5.00658C0.166504 3.93991 1.03317 3.07324 2.09984 3.07324H10.9932C12.0598 3.07324 12.9265 3.93991 12.9265 5.00658V13.8999C12.9332 14.9666 12.0598 15.8332 10.9932 15.8332ZM2.09984 4.73324C1.95317 4.73324 1.83317 4.85324 1.83317 4.99991V13.8932C1.83317 14.0399 1.95317 14.1599 2.09984 14.1599H10.9932C11.1398 14.1599 11.2598 14.0399 11.2598 13.8932V5.00658C11.2598 4.85991 11.1398 4.73991 10.9932 4.73991H2.09984V4.73324Z" fill="white" />
                    <path d="M14.9997 12.9333C14.5397 12.9333 14.1664 12.56 14.1664 12.1V2.09996C14.1664 1.95329 14.0464 1.83329 13.8997 1.83329H3.89974C3.43974 1.83329 3.06641 1.45996 3.06641 0.999959C3.06641 0.539959 3.43974 0.166626 3.89974 0.166626H13.8931C14.9597 0.166626 15.8264 1.03329 15.8264 2.09996V12.0933C15.8331 12.56 15.4597 12.9333 14.9997 12.9333Z" fill="white" />
                    <path d="M8.65961 10.2867H4.43294C3.97294 10.2867 3.59961 9.91333 3.59961 9.45333C3.59961 8.99333 3.97294 8.62 4.43294 8.62H8.65961C9.11961 8.62 9.49294 8.99333 9.49294 9.45333C9.49294 9.91333 9.11961 10.2867 8.65961 10.2867Z" fill="white" />
                </svg>
            ),
            apiName: "Remove Duplicates",
            component: '',
            popUp: false
        },
        {
            id: 3,
            svg: (
                <svg width="16" height="16" className="marg-right-5" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_504_535)">
                        <path d="M14.3699 3.6075H10.7574L9.06737 1.92749C9.09737 1.8275 9.11237 1.7225 9.11237 1.6125C9.11237 1 8.61487 0.5 7.99986 0.5C7.38486 0.5 6.88736 1 6.88736 1.6125C6.88736 1.72 6.90236 1.825 6.93236 1.925L5.24236 3.6075H1.62987C1.10236 3.6075 0.672363 4.03749 0.672363 4.565V12.2394V12.2433V14.5425C0.672363 15.07 1.10236 15.5 1.62987 15.5H14.3699C14.8974 15.5 15.3274 15.07 15.3274 14.5425V4.565C15.3274 4.03749 14.8974 3.6075 14.3699 3.6075ZM7.18736 2.375C7.39236 2.5925 7.67986 2.72749 7.99986 2.72749C8.31987 2.72749 8.60736 2.5925 8.80986 2.375L10.0474 3.6075H5.94986L7.18736 2.375ZM1.62987 4.1075H5.34486H10.6524H14.3699C14.6224 4.1075 14.8274 4.3125 14.8274 4.565V11.76L12.0449 8.97749C11.9499 8.88249 11.7849 8.88249 11.6899 8.97749L9.11986 11.55L5.36632 7.79688C5.26866 7.69922 5.11046 7.69922 5.0128 7.79688L1.17236 11.6374V4.565C1.17236 4.3125 1.37737 4.1075 1.62987 4.1075ZM1.17236 14.5425V12.3445L5.18956 8.32715L8.76494 11.9024L5.66736 15H1.62987C1.37737 15 1.17236 14.795 1.17236 14.5425Z" fill="white" />
                        <path d="M9.48016 9.06247C9.72266 9.06247 9.96766 9.00997 10.2027 8.90247C10.7002 8.66997 11.0627 8.21247 11.1702 7.67746C11.1902 7.57497 11.1502 7.46997 11.0627 7.41497C10.9777 7.35747 10.8702 7.35747 10.7877 7.41997C10.4752 7.56247 10.1027 7.42746 9.95766 7.11248C9.81266 6.79998 9.94765 6.42996 10.2627 6.27997C10.3552 6.25247 10.4252 6.17247 10.4377 6.07497C10.4502 5.97248 10.4002 5.87247 10.3102 5.82247C9.83266 5.55747 9.25016 5.53746 8.75266 5.76747C7.88766 6.16747 7.51015 7.19747 7.91016 8.05997C8.20266 8.68997 8.82766 9.06247 9.48016 9.06247Z" fill="white" />
                    </g>
                    <defs>
                        <clipPath id="clip0_504_535">
                            <rect width="16" height="16" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            ),
            apiName: "Club room images together",
            component: "",
            popUp: false
        },
        {
            id: 4,
            svg: "",
            apiName: "Add Watermark",
            component: <AddWaterMark onEnhancedImage={EnhancedImageHandler} />,
            popUp: true
        }
    ];

    const getMatchedRecommendation = (apiname: any, recommendations: any[]) => {
        return recommendations.find((rec) => rec.apiName === apiname);
    };

    const handleClick = async (apiName: any) => {
        setIsStateValue(apiName)
        setOpenPopUp(false);

        if (apiName === "Add Watermark") {
            try {
                const settings: any = await GetWatermarkSettings();
                if (settings && settings.watermarkLogo && settings.position && settings.transparency !== undefined) {
                    setLoadingItem(apiName);
                    const enhanceObj = {
                        id: "",
                        watermark: settings.watermarkLogo ? [{ id: 1, src: settings.watermarkLogo, ext: "png" }] : [],
                        position: settings.position,
                        transparent: settings.transparency,
                    };
                    props.onApplyAllImages(apiName, enhanceObj).then(() => {
                        setLoadingItem(null);
                    }).catch(() => {
                        setLoadingItem(null);
                    });
                    return;
                }
            } catch (e) {
                // proceed to popup
            }
        }

        if (getMatchedRecommendation(apiName, listEnhancement)?.popUp == true) {
            setOpenPopUp(true);
        } else {
            setLoadingItem(apiName);
            props.onApplyAllImages(apiName, null).then(() => {
                setLoadingItem(null);
            })
                .catch(() => {
                    setLoadingItem(null);
                });
        }
    };

    const handleCloseDialog = () => {
        setOpenPopUp(false);
    };

    return (
        <>
            <div className="d-flex flex-wrap align-items-center justify-content-center" style={{ gap: '10px' }}>
            {listEnhancement.map((button: any, index: any) => {
                if (button.apiName === "Add Watermark") {
                    return (
                        <div key={index} className="btn-group watermark-button-group" role="group" style={{ display: 'inline-flex', gap: '0' }}>
                            <button
                                type="button"
                                className={`button-reset back-64748B color-FFFFFF width-auto border-trans padd-15 watermark-main-btn ${props.processingIds.length !== 0 || loadingItem === button.apiName ? "disabled" : ""}`}
                                onClick={() => handleClick(button.apiName)}
                            >
                                {button.svg}
                                {t(`enhancementList.${button.apiName}`)}
                                {loadingItem == button.apiName && <div className="col-auto marg-left-5">
                                    <div className="spinner-border text-white" style={{ width: "20px", height: "20px" }} role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>}
                            </button>
                            <WatermarkSettings 
                                className="button-reset back-64748B color-FFFFFF border-trans watermark-settings-btn" 
                                svg={<SettingsIcon size={20} />} 
                                onChangeMessagehandler={(color: string, msg: string) => props.onChangeMessagehandler(msg, true, color)} 
                            />
                        </div>
                    );
                }

                return <button key={index} className={`button-reset back-64748B color-FFFFFF width-auto border-trans padd-15 ${props.processingIds.length !== 0 || loadingItem === button.apiName ? "disabled" : ""}`}
                    onClick={() => handleClick(button.apiName)}
                >
                    {button.svg}
                    {t(`enhancementList.${button.apiName}`)}
                    {button.popUp && <svg width="16" height="16" className="marg-right-5 marg-left-5" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M7.33301 1.33337H3.99967C2.52701 1.33337 1.33301 2.52737 1.33301 4.00004V12C1.33301 13.4727 2.52701 14.6667 3.99967 14.6667H11.9997C13.4723 14.6667 14.6663 13.4727 14.6663 12C14.6663 10.486 14.6663 8.66671 14.6663 8.66671C14.6663 8.29871 14.3677 8.00004 13.9997 8.00004C13.6317 8.00004 13.333 8.29871 13.333 8.66671V12C13.333 12.736 12.7357 13.3334 11.9997 13.3334C9.77967 13.3334 6.21901 13.3334 3.99967 13.3334C3.26301 13.3334 2.66634 12.736 2.66634 12C2.66634 9.78004 2.66634 6.21937 2.66634 4.00004C2.66634 3.26337 3.26301 2.66671 3.99967 2.66671H7.33301C7.70101 2.66671 7.99967 2.36804 7.99967 2.00004C7.99967 1.63204 7.70101 1.33337 7.33301 1.33337ZM12.3903 2.66671H9.99967C9.63167 2.66671 9.33301 2.36804 9.33301 2.00004C9.33301 1.63204 9.63167 1.33337 9.99967 1.33337H13.9997C14.3677 1.33337 14.6663 1.63204 14.6663 2.00004V6.00004C14.6663 6.36804 14.3677 6.66671 13.9997 6.66671C13.6317 6.66671 13.333 6.36804 13.333 6.00004V3.60937L8.47101 8.47137C8.21101 8.73137 7.78834 8.73137 7.52834 8.47137C7.26767 8.21137 7.26767 7.78871 7.52834 7.52871L12.3903 2.66671Z" fill="white" />
                    </svg>
                    }
                    {loadingItem == button.apiName && <div className="col-auto marg-left-5">
                        <div className="spinner-border text-white" style={{ width: "20px", height: "20px" }} role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>}
                </button>
            })
            }
            </div>

            <BootstrapDialog
                open={openPopUp}
                onClose={handleCloseDialog}
                aria-labelledby="customized-dialog-title"
                maxWidth="sm"
                fullWidth={true}
            >
                <DialogTitle >
                    <div className="title-24 marg-right-10 marg-left-10">{t(`enhancementList.${stateValue}`)}</div>
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleCloseDialog}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent>
                    {getMatchedRecommendation(stateValue, listEnhancement)?.component}
                </DialogContent>
            </BootstrapDialog>

        </>
    )
}

export default ApplyAllImages;